import en from './en'

// NOTE: DO NOT UPDATE THIS RESERVED TRANSLATION KEYS AND THEIR VALUES
const reservedTranslationsWithUniqueKeyNames = {
  '404': '404',
  leadingSpaceNotAllowed: 'Leerzeichen am Anfang sind nicht erlaubt.',
  trailingSpaceNotAllowed: 'Leerzeichen am Ende sind nicht erlaubt.',
  mustbeAtleastCharacters: '{{label}} muss mindestens {{minNumber}} Zeichen haben',
  cannotExceedCharacters: '{{label}} darf {{maxNumber}} Zeichen nicht überschreiten',
  numberMustbeAtleast: '{{label}} muss mindestens {{minNumber}} sein',
  numberCannotExceed: '{{label}} darf {{maxNumber}} nicht überschreiten',
  isRequired: '{{label}} ist erforderlich',
  emptySpaceNotContain: 'Dieses Feld darf kein Leerzeichen enthalten',
  register: 'Registrieren',
  login: 'Anmelden',
  comingSoon: 'Demnächst',
  submit: 'Senden',
  email: 'E-Mail',
  termsConditions: 'Allgemeine Geschäftsbedingungen',
  password: 'Passwort',
  eighteenPlus: 'Ich bin über 18 Jahre alt und stimme den Nutzungsbedingungen zu',
  signUp: 'Registrieren',
  createNewAccount: 'Neues Konto erstellen',
  fullName: 'Vollständiger Name',
  referralCode: 'Empfehlungscode',
  confirmPassword: 'Passwort bestätigen',
  facebook: ' Facebook',
  google: 'Google',
  haveAnAccount: 'Schon ein Konto? ',
  pageNotFound: 'Wir können die gesuchte Seite nicht finden!',
  error: 'Fehler',
  somethingWentWrong: 'Etwas ist schiefgelaufen!',
  personalDetails: 'Persönliche Daten',
  firstName: 'Vorname',
  lastName: 'Nachname',
  dateOfBirth: 'Geburtsdatum',
  phoneNumber: 'Telefonnummer',
  change: 'Ändern',
  saveChanges: 'Änderungen speichern',
  currentPassword: 'Aktuelles Passwort',
  newPassword: 'Neues Passwort',
  myProfile: 'Mein Profil',
  transactions: 'Transaktionen',
  deposit: 'Einzahlen',
  withdraw: 'Auszahlen',
  referral: 'Empfehlung',
  changePassword: 'Passwort ändern',
  logout: 'Abmelden',
  currency: 'Währung.',
  view: 'Ansehen',
  ok: 'OK',
  cancel: 'Abbrechen',
  userName: 'Benutzername',
  passwordRegexMatch: 'Das Passwort muss einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten',
  invalidEmailFormat: 'Ungültiges E-Mail-Format',
  noRecordsFound: 'Keine Einträge gefunden',
  backToLobby: 'Zurück zur Lobby',
  placeBet: 'Wette platzieren',
  rOICalculator: 'ROI-Rechner',
  activeBets: 'AKTIVE WETTEN',
  closedBets: 'GESCHLOSSENE WETTEN',
  publicBets: 'ÖFFENTLICHE WETTEN',
  leaderboard: 'RANGLISTE',
  howToplay: 'Spielanleitung',
  bustPriceLabel: 'Bust-Preis',
  multiplierLabel: 'MULTIPLIKATOR',
  pnLFee: 'PnL-Gebühr',
  flatFee: 'Pauschalgebühr',
  takeProfitLabel: 'GEWINN MITNEHMEN BEI PREIS',
  closeBetLabel: 'WETTE SCHLIESSEN BEI PREIS',
  priceUpLabel: 'STEIGT ODER FÄLLT DER PREIS?',
  payoutMul: 'AUSZAHLUNGSMULTIPLIKATOR',
  allCurrencies: 'Alle Währungen',
  monthLabel: 'Monat',
  day: 'Tag',
  week: 'Woche',
  betLabel: 'Wettbezeichnung',
  entryPrice: 'Einstiegspreis',
  closeBetErr: 'Geben Sie einen gültigen Betrag zum Schließen der Wette ein',
  mulValErr: 'Multiplikatorwert zwischen 100 und 1000',
  profitErr: 'Geben Sie einen gültigen Take-Profit-Betrag ein'
}

// NOTE: PLEASE ADD YOUR API SUCCESS MESSAGE TRANSLATIONS HERE ONLY
const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Anmeldung erfolgreich.',
  logoutSuccessfully: 'Abmeldung erfolgreich.',
  passwordUpdateSuccessfully: 'Passwort erfolgreich aktualisiert.',
  updatePlayerStatusSuccessfully: 'Spielerstatus erfolgreich aktualisiert.',
  resetPasswordSuccessfully: 'Passwort erfolgreich zurückgesetzt.',
  signupSuccessfully: 'Registrierung erfolgreich.',
  betPlacedSuccessfully: 'Wette erfolgreich platziert.',
  betCancelledSuccessfully: 'Wette erfolgreich storniert.'
}

// NOTE: PLEASE ADD YOUR API ERROR MESSAGE TRANSLATIONS HERE ONLY
const apiErrorMessagesTranslations = {
  UnAuthorized: 'Ihre Sitzung ist abgelaufen',
  LoginFailedError: 'Anmeldung fehlgeschlagen',
  InvalidCredentialsError: 'Ungültige Zugangsdaten',
  InvalidTokenError: ' Token ist ungültig',
  InvalidSessionError: ' Sitzung abgelaufen',
  CreateUserError: 'Benutzer kann nicht erstellt werden',
  DataMismatchError: 'Die Daten stimmen nicht überein',
  UserNotFoundError: 'Benutzer nicht gefunden',
  DuplicateEmailError: 'E-Mail existiert bereits',
  RequestInputValidationError: 'Bitte prüfen Sie die Anfragedaten',
  ResponseInputValidationError: 'Antwortvalidierung fehlgeschlagen, bitte siehe JSON-Schema der Antwort',
  SocketRequestInputValidationError: 'Bitte prüfen Sie die Anfragedaten für die Socket-Kommunikation',
  SocketResponseValidationError: 'Antwortvalidierung der Socket-Kommunikation fehlgeschlagen, bitte siehe JSON-Schema der Antwort',
  InternalServerError: 'Interner Serverfehler',
  InvalidSocketArgumentError: 'Bitte geben Sie die richtigen Argumente an: eventName, [payloadObject] und [callback]',
  InvalidCredentials: 'Die Zugangsdaten stimmen nicht überein',
  InvalidToken: 'Zugriffstoken wurde nicht übergeben oder ist abgelaufen',
  InvalidSession: 'Die Benutzersitzung ist ungültig, bitte melden Sie sich erneut an',
  InvalidAccess: 'Zugriff verweigert',
  NonOperationalError: 'Auf dem Server ist ein Fehler aufgetreten',
  UserNotExists: 'Benutzer existiert nicht',
  InvalidAction: 'Ungültige Aktion',
  SessionAlreadyStarted: 'Sitzung bereits gestartet',
  SessionNotStarted: 'Sitzung nicht gestartet',
  EmailNotVerified: 'E-Mail nicht verifiziert',
  InvalidGameTypeError: 'Keine Einstellungen für den angegebenen Spieltyp gefunden',
  InvalidGameRoundError: 'Kein Spiel für die angegebenen Spieldetails gefunden',
  NoRoundRunningError: 'Derzeit läuft keine Runde',
  NoPlacedBetFoundError: 'Keine platzierte Wette gefunden',
  NoWalletFoundError: 'Wallet mit den angegebenen Daten nicht gefunden',
  NotEnoughBalanceError: 'Das Guthaben reicht für diesen Vorgang nicht aus',
  AutoRateIsInvalidError: 'Die Auto-Rate liegt nicht im gültigen Bereich',
  BetAmountIsNotInLimitError: 'Der Wettbetrag liegt nicht in den gültigen Grenzen',
  EmailNotFound: 'E-Mail nicht gefunden',
  UserNotAbove18YearsError: 'Der Benutzer ist nicht älter als 18 Jahre',
  InvalidBlockchainAddress: 'Ungültige Blockchain-Adresse',
  AddressMismatch: 'Angegebene Adresse und wiederhergestellte Adresse stimmen nicht überein',
  NonceLifetimeExpired: 'Nonce-Gültigkeit abgelaufen',
  SomethingWentWrong: 'Etwas ist schiefgelaufen',
  AccountNotActive: 'Konto ist nicht aktiv',
  LoginTokenRequire: 'OTP (Einmalpasswort) ist erforderlich',
  UserAlreadyExists: 'Benutzer existiert bereits',
  InvalidVerificationToken: 'Ungültiges Bestätigungstoken',
  UserNotActive: 'Benutzer ist gesperrt, bitte kontaktieren Sie den Admin',
  FileUploadFailed: 'Bild-Upload fehlgeschlagen',
  EmailAlreadyVerified: 'E-Mail ist bereits verifiziert',
  InvalidReferralCode: 'Ungültiger Empfehlungscode',
  InvalidAffiliateCode: 'Ungültiger Partnercode',
  RecordNotFound: 'Eintrag nicht gefunden',
  WithdrawalRequestAlreadyPending: 'Eine Auszahlungsanfrage ist bereits ausstehend',
  WalletDoesNotBelongToUser: 'Diese Wallet gehört nicht zu diesem Benutzer',
  BetAlreadyInProgress: 'Wette ist bereits in Bearbeitung',
  ServerSeedNotFoundErrorType: 'Server-Seed nicht gefunden, bitte melden Sie sich erneut an',
  InvalidTileErrorType: 'Das Feld muss im Bereich von 1 bis 25 liegen',
  FavoriteGameExistsErrorType: 'Lieblingsspiel existiert bereits',
  FavoriteGameNotFoundErrorType: 'Lieblingsspiel nicht gefunden',
  TransactionAlreadyPendingErrorType: 'Transaktion ist bereits ausstehend',
  UserHasNoActiveBonusErrorType: 'Der Benutzer hat keinen aktiven Bonus',
  BonusExpiredErrorType: 'Der Bonus ist abgelaufen',
  UserHasAlreadyActivatedBonusWageringErrorType: 'Der Benutzer hat den Bonusumsatz bereits aktiviert',
  InvalidRoundHashErrorType: 'Falscher Runden-Hash',
  InvalidSignatureErrorType: 'Falsche Signatur',
  UserHasNoBonusAmountToClaimErrorType: 'Der Benutzer hat keinen Bonusbetrag zum Einlösen',
  BonusNotExistsErrorType: 'Bonus nicht gefunden'
}

// NOTE: PLEASE ADD YOUR OTHER KEY TRANSLATIONS HERE ONLY
const otherTranslationKeys = {
  betAmount: 'Wettbetrag',
  betHistory: 'Wettverlauf',
  provablyFair: 'Nachweislich fair',
  minimumBet: 'Mindesteinsatz',
  maximumBet: 'Höchsteinsatz',
  selectYourBetAmount: 'Wählen Sie Ihren Wettbetrag',
  buyInAmount: 'Buy-in-Betrag',
  selectYourBuyInAmountFromGivenRange: 'Wählen Sie Ihren Buy-in-Betrag aus dem angegebenen Bereich',
  profitOnWin: 'Gewinn bei Sieg',
  noOfBets: 'Anzahl der Wetten',
  auto: 'Auto',
  half: '½',
  double: '2X',
  start: 'Start',
  cancel: 'Abbrechen',
  prediction: 'Prognose',
  luckyNumber: 'Glückszahl',
  multiplier: 'Multiplikator',
  chanceToWin: 'Gewinnchance',
  betBtn: 'Wette platzieren',
  bets: 'Wetten',
  depositBtn: 'Einzahlen',
  rollOver: 'Über',
  rollUnder: 'Unter',
  invalidBetAmount: 'Ungültiger Wettbetrag',
  maxBetAmountLimit: 'Maximaler Wettbetrag {{value}} überschritten',
  minBetAmountLimit: 'Mindesteinsatz ist {{value}}.',
  noBalance: 'Der Wettbetrag ist höher als das Wallet-Guthaben',
  noAutoCashout: 'Auto-Rate ist erforderlich.',
  autoRateLimitWarning: 'Die Auto-Rate muss größer als {{value}} sein'
}

// NOTE: PLEASE ADD YOUR PREDICTION MARKET TRANSLATIONS HERE ONLY
const predictionMarketTranslations = {
  error: 'Fehler',
  somethingWentWrongPleaseTryAgain: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  market: 'Markt',
  limit: 'Limit',
  buy: 'Kaufen',
  sell: 'Verkaufen',
  yes: 'Ja',
  no: 'Nein',
  up: 'Hoch',
  down: 'Runter',
  yesCents: 'Ja {{cents}}¢',
  noCents: 'Nein {{cents}}¢',
  split: 'Split',
  merge: 'Merge',
  amount: 'Betrag',
  shares: 'Anteile',
  cancel: 'Abbrechen',
  submit: 'Senden',
  refresh: 'Aktualisieren',
  loading: 'Wird geladen',
  loadMore: 'Mehr laden',
  gotIt: 'Verstanden',
  next: 'Weiter',
  previous: 'Zurück',
  trade: 'Handeln',
  portfolio: 'Portfolio',
  rules: 'Regeln',
  volume: 'Volumen',
  category: 'Kategorie',
  notAvailable: 'k. A.',
  open: 'Offen',
  closed: 'Geschlossen',
  removed: 'Entfernt',
  resolved: 'Entschieden',
  cancelled: 'Storniert',
  settled: 'Abgerechnet',
  ask: 'Ask',
  bid: 'Bid',
  asks: 'Asks',
  bids: 'Bids',
  total: 'Gesamt',
  outcome: 'Ergebnis',
  options: 'Optionen',
  history: 'Verlauf',
  positions: 'Positionen',
  orders: 'Orders',
  activity: 'Aktivität',
  comments: 'Kommentare',
  delete: 'Löschen',
  reply: 'Antworten',
  postComment: 'Kommentar posten',
  likeCount: 'Gefällt mir ({{count}})',
  limitPrice: 'Limitpreis',
  postOnly: 'Nur einstellen',
  youPay: 'Sie zahlen',
  shareCost: 'Anteilskosten',
  toWin: 'Zu gewinnen',
  youWillReceive: 'Sie erhalten',
  averagePrice: 'Durchschnittspreis',
  payable: 'Zu zahlen',
  processingFee: 'Bearbeitungsgebühr',
  processingFees: 'Bearbeitungsgebühren',
  estProcessingFee: 'Geschätzte Bearbeitungsgebühr',
  estProcessingFeeIncluded: 'Geschätzte Bearbeitungsgebühr (enthalten)',
  processingFeeRefundable: 'Bearbeitungsgebühr (erstattbar)',
  showMore: 'mehr anzeigen...',
  feePerShareIfItFillsNow: 'Gebühr pro Anteil, wenn jetzt ausgeführt',
  marketSettled: 'Markt abgerechnet',
  resultDeclared: 'Ergebnis bekannt gegeben',
  tradingClosedForThisOption: 'Der Handel für diese Option ist geschlossen.',
  waitingForNextMarket: 'Noch kein Live-Markt. Der Handel öffnet mit dem nächsten Fenster.',
  cryptoLiveNavLabel: 'Live Crypto',
  goBack: 'Zurück',
  yourPosition: 'Ihre Position',
  availableToTrade: 'Zum Handel verfügbar',
  locked: 'Gesperrt',
  profitLoss: 'G/V',
  yesShares: 'Ja-Anteile',
  noShares: 'Nein-Anteile',
  avgYesPrice: 'Ø Ja-Preis',
  avgNoPrice: 'Ø Nein-Preis',
  outcomeShares: '{{outcome}}-Anteile',
  avgOutcomePrice: '{{outcome}}-Durchschnittspreis',
  payoutProfitLoss: 'Auszahlung G/V',
  outcomeWon: '{{outcome}} gewonnen',
  buyOutcome: '{{outcome}} kaufen',
  sellOutcome: '{{outcome}} verkaufen',
  decreaseAmount: 'Betrag verringern',
  increaseAmount: 'Betrag erhöhen',
  decreaseShares: 'Anteile verringern',
  increaseShares: 'Anteile erhöhen',
  decreaseLimitPrice: 'Limitpreis verringern',
  increaseLimitPrice: 'Limitpreis erhöhen',
  nobodySellingRightNow: 'Derzeit verkauft niemand. Versuchen Sie eine Limitorder, damit Ihre Order warten kann.',
  nobodyBuyingRightNow: 'Derzeit kauft niemand. Versuchen Sie eine Limitorder, damit Ihre Order warten kann.',
  tooMuchMaxBuy: 'Zu viel. Maximal können Sie jetzt {{amount}}$ kaufen.',
  tooManySharesMaxSell: 'Zu viele Anteile. Maximal können Sie jetzt {{amount}} verkaufen.',
  restAsMakerOnly: 'Nur als Maker einstellen; abgelehnt, wenn Liquidität genommen würde',
  mergeMatchedSharesIntoCollateral: 'Passende Ja- und Nein-Anteile wieder in Sicherheiten zusammenführen.',
  sharesPerSide: 'Anteile (pro Seite)',
  splitCollateralIntoShares: 'Sicherheiten in Ja- und Nein-Anteile für diesen Markt aufteilen.',
  closeTradePanel: 'Handelspanel schließen',
  openTradePanel: 'Handelspanel öffnen',
  orderSummary: 'Orderübersicht',
  youSell: 'Sie verkaufen',
  youMerge: 'Sie führen zusammen',
  estProceedsAtMarket: 'Geschätzter Erlös zum Markt',
  splitCollateral: 'Sicherheiten aufteilen',
  mergeShares: 'Anteile zusammenführen',
  splitHasNoProcessingFee: 'Split hat keine Bearbeitungsgebühr.',
  mergeHasNoProcessingFee: 'Merge hat keine Bearbeitungsgebühr.',
  includedInWhatYouPay: 'Im zu zahlenden Betrag enthalten. Gilt, wenn Ihre Order verfügbare Angebote trifft.',
  deductedFromWhatYouReceive: 'Vom erhaltenen Betrag abgezogen, wenn Ihre Order verfügbare Bids trifft.',
  heldWithYourOrder: 'Wird mit Ihrer Order gehalten. Erstattet, wenn sie im Buch wartet. Einbehalten nur, wenn sie sofort ausgeführt wird.',
  onlyIfOrderFillsRightAway: 'Nur wenn Ihre Order sofort ausgeführt wird — vom Erlös abgezogen. Keine Gebühr, wenn sie im Buch wartet.',
  makerFeeRebateExplanation: 'Wenn jemand anderes Ihre wartende Order nimmt, können Sie {{rebatePercent}}% von dessen Gebühr verdienen.',
  postOnlyOrderExplanation: 'Nur einstellen: Diese Order wartet nur. Wenn sie sofort ausgeführt würde, wird sie storniert und Sie erhalten Ihr Geld zurück.',
  notEnoughMoneyInWallet: 'Nicht genug Geld in Ihrer Wallet.',
  notEnoughYesAndNoSharesToMerge: 'Nicht genug Ja- und Nein-Anteile zum Zusammenführen.',
  notEnoughSharesToSell: 'Sie haben nicht so viele Anteile zum Verkaufen.',
  maxOrderSizeIs: 'Maximale Ordergröße ist {{amount}}.',
  orderCrossesOwnSellOrder: 'Die Order würde Ihre eigene Verkaufsorder für dieses Ergebnis kreuzen. Stornieren oder senken Sie zuerst diesen Verkauf.',
  orderCrossesOwnOppositeBuy: 'Die Order würde Ihren eigenen Kauf der Gegenseite kreuzen (Ja+Nein >= 100¢). Stornieren oder passen Sie diese Order zuerst an.',
  orderCrossesOwnBuyOrder: 'Die Order würde Ihre eigene Kauforder für dieses Ergebnis kreuzen. Stornieren oder erhöhen Sie zuerst diesen Kauf.',
  placedBuyLimitOrder: 'Kauflimitorder über {{shares}} Anteile zum Preis {{price}} platziert',
  placedSellLimitOrder: 'Verkaufslimitorder über {{shares}} Anteile zum Preis {{price}} platziert',
  placedBuyMarketOrder: 'Kaufmarktorder über den Betrag {{amount}} platziert',
  placedSellMarketOrder: 'Verkaufsmarktorder über {{shares}} Anteile platziert',
  mergedYesAndNoShares: '{{quantity}} Ja- und Nein-Anteile in den Betrag {{amount}} zusammengeführt',
  splitAmountIntoYesAndNoShares: 'Betrag {{amount}} in {{yesShares}} Ja-Anteile und {{noShares}} Nein-Anteile aufgeteilt',
  closedBuyLimitOrder: 'Kauflimitorder über {{remainingShares}} Anteile zum Preis {{price}} geschlossen, gesamt {{shares}}',
  closedSellLimitOrder: 'Verkaufslimitorder über {{remainingShares}} Anteile zum Preis {{price}} geschlossen, gesamt {{shares}}',
  closedBuyMarketOrder: 'Kaufmarktorder über den Betrag {{remainingAmount}} geschlossen, gesamt {{amount}}',
  closedSellMarketOrder: 'Verkaufsmarktorder über {{remainingShares}} Anteile geschlossen, gesamt {{shares}}',
  boughtSharesFromSeller: '{{quantity}} Anteile zum Preis {{price}} von {{sellerName}} gekauft',
  soldSharesToBuyer: '{{quantity}} Anteile zum Preis {{price}} an {{buyerName}} verkauft',
  marketResolvedWithOutcome: 'Markt mit Ergebnis {{outcome}} entschieden. Auszahlung: ${{payout}} ({{winningShares}} gewinnende Anteile).',
  buyerReceivedSharesSystemMinted: '{{buyerName}} erhielt {{quantity}} Anteile zu {{price}} (vom System ausgegeben)',
  buyerBoughtSharesFromSeller: '{{buyerName}} kaufte {{quantity}} Anteile zu {{price}} von {{sellerName}}',
  sellerSoldSharesToSystem: '{{sellerName}} verkaufte {{quantity}} Anteile zu {{price}} an SYSTEM',
  sellerSoldSharesToBuyer: '{{sellerName}} verkaufte {{quantity}} Anteile zu {{price}} an {{buyerName}}',
  notifications: 'Benachrichtigungen',
  unreadNotifications: '{{count}} ungelesene Benachrichtigungen',
  recentCount: '{{count}} kürzlich',
  loadingNotifications: 'Benachrichtigungen werden geladen...',
  noNotificationsYet: 'Noch keine Benachrichtigungen. Sie werden benachrichtigt, wenn Orders gematcht oder abgeschlossen werden oder Märkte entschieden werden.',
  activityUpdate: 'Aktivitätsupdate',
  marketResolved: 'Markt entschieden',
  marketQuestionResolved: 'Der Markt "{{questionTitle}}" wurde entschieden.',
  walletUpdated: 'Wallet aktualisiert',
  justNow: 'Gerade eben',
  pickAMarket: 'Markt wählen',
  pickAMarketDescription: 'Öffnen Sie einen Markt und wählen Sie Ja oder Nein entsprechend Ihrer Prognose. Nutzen Sie dann das Orderpanel, um Anteile zu erhalten.',
  preferLimitOrders: 'Limitorders bevorzugen',
  preferLimitOrdersDescription: 'Beginnen Sie hier. Legen Sie den genauen Preis (¢) und die Anzahl der Anteile fest. Ihre Order bleibt im Buch, bis jemand sie matcht — so bestimmen Sie den Preis.',
  noFillUseSplit: 'Keine Ausführung? Split nutzen',
  noFillUseSplitDescription: 'Wenn nicht genug Liquidität für eine Limitorder da ist, teilen Sie Ihre Sicherheiten in gleiche Ja- und Nein-Anteile. Die unerwünschte Seite können Sie danach verkaufen.',
  needSpeedMarketOrders: 'Schnelligkeit nötig? Marktorders',
  needSpeedMarketOrdersDescription: 'Marktorders werden sofort gegen das aktuelle Orderbuch ausgeführt. Nutzen Sie sie, wenn Sie Anteile jetzt wollen und den aktuellen Marktpreis zahlen möchten.',
  holdOrCashOut: 'Halten oder auszahlen',
  holdOrCashOutDescription: 'Verkaufen Sie jederzeit vor der Entscheidung oder halten Sie bis zur Abrechnung. Gewinnende Anteile zahlen je 1 $, verlierende werden mit 0 $ abgerechnet.',
  restsOnTheBookUntilMatched: 'Bleibt im Buch, bis sie gematcht wird',
  convertCashIntoYesAndNoShares: 'Bargeld in Ja- + Nein-Anteile umwandeln',
  estShares: 'Geschätzte Anteile',
  fillsInstantlyAtBookPrices: 'Wird sofort zu Buchpreisen ausgeführt',
  resolvedYes: 'Entschieden · Ja',
  payoutCredited: 'Auszahlung gutgeschrieben',
  closeHowItWorks: 'So funktioniert es schließen',
  tryItOut: 'Ausprobieren?',
  willThereBeAUsRecessionThisYear: 'Wird es dieses Jahr eine US-Rezession geben?',
  exitTutorialAndReturnToMarkets: 'Tutorial verlassen und zu den Märkten zurückkehren',
  exitDemo: 'Demo verlassen',
  howItWorks: 'So funktioniert es',
  demoGuide: 'Anleitung',
  demoGuideReopen: 'Demo-Anleitung erneut öffnen',
  demoGuideSkip: 'Anleitung überspringen',
  demoGuideFinish: 'Fertig',
  demoGuideStepOf: 'Schritt {{current}} von {{total}}',
  demoGuideBack: 'Zurück',
  demoGuideWelcomeTitle: 'Willkommen auf dem Spielplatz',
  demoGuideWelcomeBody: 'Dies ist ein sicherer Demomarkt mit Spielgeld. Ich zeige auf jedes UI-Element und erkläre, was es tut — probieren Sie die Aktion aus oder tippen Sie jederzeit auf Weiter.',
  demoGuideWelcomeHint: 'Sie starten mit 1000 $ Demoguthaben. Hier ist nichts echt.',
  demoGuideLimitTitle: 'Limitorders bevorzugen',
  demoGuideLimitBody: 'Eine Limitorder lässt Sie den genauen Preis (¢) und die Anzahl der Anteile festlegen. Sie bleibt im Buch, bis jemand sie matcht — so bestimmen Sie den Preis statt den aktuellen zu nehmen.',
  demoGuideLimitHint: 'Ich habe Limit geöffnet und Kauf Ja zu 45¢ × 10 vorgeschlagen. Senden Sie, wenn Sie es versuchen möchten, oder Weiter, um weiterzulesen.',
  demoGuideOrderbookTitle: 'Ihre Order im Buch',
  demoGuideOrderbookBody: 'Das Orderbuch zeigt wartende Bids und Asks. Wenn Sie eine Limitorder platzieren, erscheint sie hier (oft mit Sie markiert), bis sie ausgeführt oder storniert wird.',
  demoGuideOrderbookHint: 'Wenn Sie noch keine wartende Order haben, platziere ich ein kleines Demo-Bid, damit Sie sehen, wie es aussieht.',
  demoGuidePostOnlyTitle: 'Nur einstellen (nur Maker)',
  demoGuidePostOnlyBody: 'Nur einstellen bedeutet, dass Ihr Limitkauf nur als Maker wartet. Wenn der Preis sofort gegen einen Ask ausgeführt würde, wird die Order abgelehnt und Ihr Geld kommt zurück — nützlich, wenn Sie nie Liquidität nehmen wollen.',
  demoGuidePostOnlyHint: 'Nur einstellen ist aktiv, ein nicht kreuzendes 45¢-Bid ist bereit. Versuchen Sie zu senden oder Weiter, um fortzufahren.',
  demoGuideCancelTitle: 'Eine wartende Order stornieren',
  demoGuideCancelBody: 'Meinung geändert? Offene Orders stehen unter Meine Position. Stornieren gibt bei Käufen reserviertes Geld frei (oder bei Verkäufen gesperrte Anteile), damit Sie es wieder nutzen können.',
  demoGuideCancelHint: 'Nutzen Sie Abbrechen in einer Zeile, wenn Sie üben möchten — ich halte ein wartendes Bid für Sie bereit.',
  demoGuideMarketTitle: 'Schnelligkeit nötig? Marktorders',
  demoGuideMarketBody: 'Marktorders werden sofort gegen das aktuelle Buch ausgeführt. Nutzen Sie sie, wenn Sie Anteile jetzt wollen und aktuelle Ask-Preise zahlen statt auf Ihr eigenes Limit zu warten.',
  demoGuideMarketHint: 'Ich habe einen Kauf über 5 $ auf Markt gesetzt. Senden Sie, um eine sofortige Ausführung zu sehen, oder Weiter, um fortzufahren.',
  demoGuideMintTitle: 'Keine Asks? Mint funktioniert trotzdem',
  demoGuideMintBody: 'Wenn niemand verkauft, können Sie trotzdem Anteile erhalten. Die Engine kann Ja+Nein aus Sicherheiten ausgeben, indem sie Ihren Kauf mit einem Bid der Gegenseite matcht — leere Asks bedeuten also nicht immer „festgefahren“.',
  demoGuideMintHint: 'Ich habe die Asks dieser Option geleert. Eine Marktkauforder über 5 $ ist bereit — sehen Sie, wie Anteile auch bei leerer Ask-Seite erscheinen.',
  demoGuideSplitTitle: 'Keine Ausführung? Split nutzen',
  demoGuideSplitBody: 'Split wandelt Sicherheiten sofort in gleiche Ja- und Nein-Anteile um — ohne Gegenpartei. Praktisch, wenn das Buch dünn ist und Sie Bestand wollen, um die unerwünschte Seite später zu verkaufen.',
  demoGuideSplitHint: 'Ich habe vorgeschlagen, 10 $ zu splitten. Probieren Sie es, um Ja und Nein steigen zu sehen, oder Weiter, um fortzufahren.',
  demoGuideMergeTitle: 'Zurück zu Bargeld mergen',
  demoGuideMergeBody: 'Merge ist das Gegenteil von Split: gleiche Ja- und Nein-Anteile verbrennen, um Sicherheiten zurückzubekommen. Nützlich, wenn Sie beide Seiten halten und in Bargeld glätten wollen.',
  demoGuideMergeHint: 'Ich habe vorgeschlagen, 5 pro Seite zu mergen. Sie brauchen passende verfügbare Ja und Nein — splitten Sie zuerst, falls nötig.',
  demoGuideResolveTitle: 'Schließen und abrechnen',
  demoGuideResolveBody: 'Wenn der Handel endet, schließt der Markt und wird dann abgerechnet. Gewinnende Anteile zahlen je 1 $, verlierende werden mit 0 $ abgerechnet. In der Demo lässt Sie Markt verwalten Schließen → Gewinner wählen → Abrechnen simulieren.',
  demoGuideResolveHint: 'Öffnen Sie das Panel, falls es nicht offen ist. Zuerst schließen, dann Ja/Nein wählen und für die gewählte Option abrechnen.',
  demoGuideDoneTitle: 'Sie kennen die Grundlagen',
  demoGuideDoneBody: 'Limit für Preiskontrolle, Nur einstellen um Maker zu bleiben, Stornieren um reservierte Mittel freizugeben, Markt für Tempo, Mint wenn Asks leer sind, Split/Merge für Bestand und Markt verwalten für die Entscheidung.',
  demoGuideDoneHint: 'Jederzeit über die Schaltfläche Anleitung wiederholen. Demogeld wird zurückgesetzt, wenn Sie den Demomodus erneut betreten.',
  demoGuideWaitingForAction: 'Schließen Sie die markierte Aktion ab, um fortzufahren.',
  demoGuideDoThisFirst: 'Zuerst dies tun',
  ganamosPolyTrade: 'Ganamos PolyTrade',
  trending: 'Im Trend',
  new: 'Neu',
  buyYes: 'Ja kaufen',
  breaking: 'Eilmeldung',
  noBreakingMarketsRightNow: 'Derzeit keine Eilmärkte.',
  backToMarkets: 'Zurück zu den Märkten',
  markets: 'Märkte',
  openFullMarket: 'Vollständigen Markt öffnen',
  tradeMarket: 'Markt handeln',
  previousMarket: 'Vorheriger Markt',
  nextMarket: 'Nächster Markt',
  breakingMarkets: 'Eilmärkte',
  showBreakingMarket: 'Eilmarkt {{index}} anzeigen',
  featuredMarkets: 'Hervorgehobene Märkte',
  topMovers: 'Top-Bewegungen',
  viewAll: 'Alle anzeigen',
  liveTrades: 'Live-Trades',
  live: 'Live',
  featuredMarket: 'Hervorgehobener Markt',
  untitledMarket: 'Markt ohne Titel',
  traders: 'Händler',
  endsIn: 'Endet in',
  tradeNow: 'Jetzt handeln',
  showFeaturedMarket: 'Hervorgehobenen Markt {{index}} anzeigen',
  openNewsHeadline: 'Nachricht öffnen: {{headline}}',
  openNewsStatus: 'Nachricht öffnen: {{statusText}}',
  news: 'Nachrichten',
  minimizeNews: 'Nachrichten minimieren',
  expandNews: 'Nachrichten erweitern',
  closeNews: 'Nachrichten schließen',
  liveWire: 'Live-Ticker',
  categoryNews: 'Nachrichten {{category}}',
  categoryDesk: 'Redaktion {{category}}',
  topHeadlinesAndRelatedCoverage: 'Top-Schlagzeilen und verwandte Berichte für diese Marktkategorie',
  topHeadlinesCount: 'Top {{count}} Schlagzeilen',
  moreRelevantNews: 'Weitere relevante Nachrichten',
  noNewsStoriesForThisCategoryYet: 'Noch keine Nachrichten für diese Kategorie.',
  pullingHeadlinesFromTheWire: 'Schlagzeilen werden vom Ticker geladen…',
  scanningWire: 'Ticker wird durchsucht…',
  categoryWaitingForStories: '{{category}} · wartet auf Meldungen',
  categoryStoriesCount: '{{category}} · {{count}} Meldungen',
  searchMarkets: 'Märkte suchen...',
  searchPortfolioActivity: 'Portfolio-Aktivität suchen',
  refreshPortfolioActivity: 'Portfolio-Aktivität aktualisieren',
  portfolioSections: 'Portfolio-Bereiche',
  noPositionsFound: 'Keine Positionen gefunden',
  yourOwnedPositionsWillAppearHere: 'Ihre gehaltenen Positionen erscheinen hier.',
  noOrdersFound: 'Keine Orders gefunden',
  marketOrdersWillAppearInThisSection: 'Marktorders erscheinen in diesem Bereich.',
  limitOrdersWillAppearInThisSection: 'Limitorders erscheinen in diesem Bereich.',
  noActivityYet: 'Noch keine Aktivität',
  completedTradesAndSettlementsWillBeListedHere: 'Abgeschlossene Trades und Abrechnungen werden hier aufgelistet.',
  cancelThisOrder: 'Diese Order stornieren?',
  cancelThisOrderDescription: 'Dadurch wird Ihre offene Limitorder aus dem Buch entfernt. Sie können jederzeit eine neue platzieren.',
  keepOrder: 'Order behalten',
  cancelOrder: 'Order stornieren',
  yourTradingDesk: 'Ihr Handelstisch',
  stateFilters: 'Statusfilter',
  tablePagination: 'Tabellenpaginierung',
  pagination: 'Paginierung',
  previousPage: 'Vorherige Seite',
  nextPage: 'Nächste Seite',
  noDataAvailable: 'Keine Daten verfügbar',
  dataWillAppearHere: 'Daten erscheinen hier',
  thumbnail: 'Vorschaubild',
  actions: 'Aktionen',
  rowThumbnail: 'Zeilenvorschaubild',
  yourPerformance: 'Ihre Leistung',
  walletBalance: 'Wallet-Guthaben',
  totalProfitIncludingTakerFee: 'Gesamtgewinn inklusive Taker-Gebühr',
  totalProfit: 'Gesamtgewinn',
  hideTakerFee: 'Taker-Gebühr ausblenden',
  showTakerFee: 'Taker-Gebühr anzeigen',
  profitOverTime: 'Gewinn im Zeitverlauf',
  noChartDataAvailable: 'Keine Diagrammdaten verfügbar',
  profitHistoryWillAppearAsTradesArePlaced: 'Der Gewinnverlauf erscheint, sobald Trades platziert werden.',
  profitChartTimeRange: 'Zeitraum des Gewinndiagramms',
  userActivity: 'Benutzeraktivität',
  userActivityTitle: 'Benutzeraktivität',
  userActivityTabs: 'Reiter der Benutzeraktivität',
  refreshUserActivity: 'Benutzeraktivität aktualisieren',
  addYourComment: 'Kommentar hinzufügen',
  shareYourThoughtsAboutThisMarket: 'Teilen Sie Ihre Gedanken zu diesem Markt...',
  anonymous: 'anonym',
  hideReplies: 'Antworten ausblenden',
  showReplies: 'Antworten anzeigen',
  writeAReply: 'Antwort schreiben...',
  loadingEllipsis: 'Wird geladen...',
  recentMarketBuysAndSellsWillAppearHere: 'Aktuelle Marktkäufe und -verkäufe erscheinen hier.',
  topHolders: 'Top-Inhaber',
  topPositions: 'Top-Positionen',
  noTopPositionsFound: 'Keine Top-Positionen gefunden',
  topPositionsWillAppearHereWithHighestRealizedPnl: 'Hier erscheinen die Top-Positionen mit dem höchsten realisierten PnL',
  yesHolders: 'Ja-Inhaber',
  noHolders: 'Nein-Inhaber',
  noTopHoldersFoundForYesOutcome: 'Keine Top-Inhaber für das Ergebnis Ja gefunden',
  topHoldersWillAppearHereForYesOutcome: 'Die Top-Inhaber für das Ergebnis Ja erscheinen hier',
  noTopHoldersFoundForNoOutcome: 'Keine Top-Inhaber für das Ergebnis Nein gefunden',
  topHoldersWillAppearHereForNoOutcome: 'Die Top-Inhaber für das Ergebnis Nein erscheinen hier',
  optionDetailsTabs: 'Reiter der Optionsdetails',
  orderbookOutcome: 'Orderbuch-Ergebnis',
  orderbook: 'Orderbuch',
  graph: 'Diagramm',
  myPosition: 'Meine Position',
  yesBook: 'Ja-Buch',
  noBook: 'Nein-Buch',
  spread: 'Spread',
  you: 'Sie',
  noAsks: 'Keine Asks',
  noBids: 'Keine Bids',
  loadingPosition: 'Position wird geladen...',
  yourOrders: 'Ihre Orders',
  marketOrdersForThisOptionWillAppearHere: 'Marktorders für diese Option erscheinen hier.',
  limitOrdersForThisOptionWillAppearHere: 'Limitorders für diese Option erscheinen hier.',
  rulesAndMarketContext: 'Regeln und Marktkontext',
  marketResolvesBasedOnListedCriteriaAndFinalOutcomeData: 'Der Markt wird anhand der aufgeführten Kriterien und der endgültigen Ergebnisdaten entschieden.',
  matchingEngineSettlesOpenOrdersUsingMarketResolutionRules: 'Die Matching-Engine rechnet offene Orders nach den Marktentscheidungsregeln ab.',
  ambiguousOutcomesAreHandledByPlatformAdjudicationPolicy: 'Mehrdeutige Ergebnisse werden nach der Schlichtungsrichtlinie der Plattform behandelt.',
  defaultPredictionMarketRules: `
  Regeln:
  - Dieser Markt wird anhand des in der Frage beschriebenen Ergebnisses entschieden. Für die Entscheidung werden öffentlich verfügbare und zuverlässige Quellen wie offizielle Erklärungen, verifizierte Datenanbieter oder seriöse Nachrichtenorganisationen verwendet. 
  - Wenn das Ergebnis vor dem angegebenen Enddatum klar wird, kann der Markt vorzeitig entschieden werden. Wenn das Ereignis nicht bestimmt werden kann oder die Frage mehrdeutig wird, kann die Plattform den Markt nach bestem Ermessen auf Basis der verfügbaren Informationen entscheiden.
  - Alle Entscheidungen sind endgültig.`,
  pleaseLogInToFavouriteQuestions: 'Bitte melden Sie sich an, um Fragen zu favorisieren.',
  removeFromFavourites: 'Aus Favoriten entfernen',
  addToFavourites: 'Zu Favoriten hinzufügen',
  unableToUpdateFavouriteQuestionPleaseTryAgain: 'Favoritenfrage konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
  marketOrderInProgress: 'Marktorder in Bearbeitung',
  noActiveMarketOrder: 'Keine aktive Marktorder',
  marketOrderRunning: 'Marktorder läuft',
  remainingAmount: 'Verbleibend: ${{amount}}',
  remainingShares: 'Verbleibend: {{shares}} Anteile',
  statusState: 'Status: {{state}}',
  noMarketOrderRunning: 'Keine Marktorder aktiv. Vergangene Marktorders finden Sie im Tab Orders auf Ihrer Portfolio-Seite.',
  deposit: 'Einzahlen',
  withdraw: 'Auszahlen',
  closeWalletActivityModal: 'Wallet-Aktivitätsfenster schließen',
  enterAmountToAction: 'Betrag eingeben zum {{action}}',
  depositSuccessful: 'Einzahlung erfolgreich',
  depositFailedPleaseTryAgain: 'Einzahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  withdrawalSuccessful: 'Auszahlung erfolgreich',
  withdrawFailedPleaseTryAgain: 'Auszahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  mergeSuccessfulBalanceCredited: 'Merge erfolgreich. Guthaben gutgeschrieben.',
  mergeSuccessfulCreditPending: 'Merge erfolgreich. Gutschrift ausstehend — das Guthaben wird in Kürze aktualisiert.',
  orderPlacedSuccessfully: 'Order erfolgreich platziert',
  placeOrderFailedPleaseTryAgain: 'Order konnte nicht platziert werden. Bitte versuchen Sie es erneut.',
  orderCancelledSuccessfully: 'Order erfolgreich storniert',
  cancelLimitOrderFailedPleaseTryAgain: 'Limitorder konnte nicht storniert werden. Bitte versuchen Sie es erneut.',
  commentAdded: 'Kommentar hinzugefügt',
  addCommentFailedPleaseTryAgain: 'Kommentar konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.',
  commentDeleted: 'Kommentar gelöscht',
  deleteCommentFailedPleaseTryAgain: 'Kommentar konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
  failedToLoadNotifications: 'Benachrichtigungen konnten nicht geladen werden',
  commentCannotBeEmpty: 'Kommentar darf nicht leer sein.',
  commentNotFound: 'Kommentar nicht gefunden.',
  demoMultiOutcomeMarket: 'Demo-Markt mit mehreren Ergebnissen',
  outcomeAlpha: 'Ergebnis Alpha',
  outcomeBeta: 'Ergebnis Beta',
  outcomeGamma: 'Ergebnis Gamma',
  greatMarketToLearnLimitOrders: 'Guter Markt, um Limitorders zu lernen — versuchen Sie ein Bid unter dem aktuellen Preis.',
  theOrderbookUpdatesLiveOnceYouStartPlacingDemoOrders: 'Das Orderbuch aktualisiert sich live, sobald Sie Demo-Orders platzieren.',
  demoOutcome: 'Demo-Ergebnis',
  demoMarketControls: 'Demo-Marktsteuerung',
  simulateCloseAndSettlementToSeeHowTheMarketBehaves: 'Schließen und Abrechnung simulieren, um zu sehen, wie sich der Markt verhält.',
  closePanel: 'Panel schließen',
  closeMarket: 'Markt schließen',
  tradingOpen: 'Handel offen',
  stopsTradingClearsTheOrderbookAndClosesOpenOrders: 'Stoppt den Handel, leert das Orderbuch und schließt offene Orders. Verbleibende vorausbezahlte Beträge auf Bid-Orders gehen zurück in Ihre Wallet. Positionen bleiben bis zur Abrechnung offen.',
  marketClosed: 'Markt geschlossen',
  settleMarket: 'Markt abrechnen',
  ready: 'Bereit',
  awaitingClose: 'Wartet auf Schließung',
  pickTheWinningOutcomeDescription: 'Wählen Sie das gewinnende Ergebnis. Gewinnende Anteile zahlen je 1 $, Positionen werden geleert und Optionen zeigen sich als abgerechnet mit dem Endergebnis.',
  winningOutcome: 'Gewinnendes Ergebnis',
  settlementOutcome: 'Abrechnungsergebnis',
  closeManageMarketPanel: 'Panel Markt verwalten schließen',
  manageMarket: 'Markt verwalten',
  manageDemoMarket: 'Demomarkt verwalten',
  noChartDataYet: 'Noch keine Diagrammdaten',
  priceHistoryWillAppearHereAsTradesHappen: 'Der Preisverlauf erscheint hier, sobald Trades stattfinden.',
  chartTimeRange: 'Zeitraum des Diagramms',
  allMarkets: 'Alle Märkte',
  backToCollateral: 'Zurück zu Sicherheiten · {{marketTitle}}',
  demo: 'Demo',
  depositing: 'Einzahlung läuft...',
  equalYesAndNoShares: 'Gleiche Ja- und Nein-Anteile · {{marketTitle}}',
  estValue: 'Geschätzt {{value}}',
  favouriteQuestions: 'Favoritenfragen',
  favourites: 'Favoriten',
  feePerShareFormula: 'Gebühr pro Anteil (¢) = Preis × (100 − Preis) × {{coefficient}} / 10,000',
  limitBuy: 'Limitkauf',
  limitSell: 'Limitverkauf',
  marketBuyOn: 'Marktkauf auf {{marketTitle}}',
  marketSellOn: 'Marktverkauf auf {{marketTitle}}',
  marketResolutionPayoutReceived: 'Auszahlung der Marktentscheidung erhalten. Neues Guthaben: {{currency}} {{formattedBalance}}',
  marketsPagination: 'Marktpaginierung',
  noFavouriteQuestionsYet: 'Noch keine Favoritenfragen.',
  noTitle: 'Kein Titel',
  optionNumber: 'Option {{number}}',
  postOnlyLimitBuy: 'Limitkauf nur einstellen',
  system: 'SYSTEM',
  unknownOrderType: 'Unbekannter Ordertyp: {{orderType}}',
  withdrawing: 'Auszahlung läuft...',
  yourBalanceWasCredited: 'Ihr Guthaben wurde gutgeschrieben. Neues Guthaben: {{currency}} {{formattedBalance}}',
  yourBalanceWasDebited: 'Ihr Guthaben wurde belastet. Neues Guthaben: {{currency}} {{formattedBalance}}',
  thisMarket: 'dieser Markt',
  yourPositionText: 'Ihre Position',
  amountYesAndNo: '{{amount}} Ja + {{amount}} Nein',
  daysAgo: 'vor {{days}} T',
  hoursAgo: 'vor {{hours}} Std.',
  minutesAgo: 'vor {{minutes}} Min.',
  outcomeSharesAtMarket: '{{outcome}}-Anteile zum Markt',
  sharesYesAndNo: '{{shares}} Ja + {{shares}} Nein',
  sharesOutcomeAtPrice: '{{shares}} {{outcome}} @ {{price}}¢ · {{marketTitle}}',
  sharesOutcome: '{{shares}} Anteile {{outcome}}'
}


/**
 * NOTE:
 * =================================================================================================
 * Please go through this spreading objects first before adding new translation key. So that the
 * duplicate translations will not be created and help us to maintain the consitency of code.
 * If you didn't find any of translation as per your requirement in reserve or api success & error
 * msg translation object, Please add new translation with unique key name in otherTranslationKeys
 * Object. Unique key names help us to avoid overriding of translations.
 * =================================================================================================
 */
export default {
  ...en,
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys,
  ...predictionMarketTranslations
}
